import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StatusRegisterDTO } from 'app/consulta-mark-list/interface/newStatusRegister';
import { InfoClienteService } from 'app/consulta-mark-list/service/BehaviorSubject/infoClient.service';
import { ConsultaMarkListService } from 'app/consulta-mark-list/service/consulta-mark-list.service';
import { FormatToService } from 'app/consulta-mark-list/service/Validators/format-to.service';
import { SinisterService } from 'app/service/sinister.service';

import { iif, Subscription } from 'rxjs';

import {
  AmaruViewGenericClass,
  NotificationRequestService,
  ShowInCountryService,
} from 'amaru-web-components';
import { DynamicInputForm, OptionCombobox } from 'app/core/interfaces';
import { AuthService, UserInfoDTO } from 'base-angular-avla';
import moment from 'moment';
import {
  AvlaGenericComponent,
  I18nService,
  InfoMessageDTO,
  MessageService,
} from 'shared-angular-components-avla';

import { Router } from '@angular/router';
import { States } from 'app/core/enums';

@Component({
  selector: 'app-ml-status-person',
  templateUrl: './ml-status-person.component.html',
  styleUrls: ['./ml-status-person.component.css'],
})
export class MlStatusPersonComponent
  extends AmaruViewGenericClass
  implements OnInit
{
  @Input() statusData: any[];
  @Input() personData: any;
  @Input() editMode: boolean;
  @Output() refresh = new EventEmitter();

  showInCountryService: any = ShowInCountryService;

  mostrarBtnAgregarRegistro = false;
  infoClient: Subscription;
  mostrarAgregarRegistro = false;
  reactiveForm: FormGroup;

  dinamicFormInputsData: DynamicInputForm[];
  idStatusList: any[] = [];
  idStatusListCopy: any[] = [];
  idStatusListEditMode: any[] = [];
  sistemasBloquear: any[] = [];
  loadingImgRegisterType: boolean;
  isLoadingSubarea: boolean;
  loadingImgAlertType: boolean;
  loadingImg = false;
  localData: any;
  noEditItem = false;
  userSeguimiento: any;
  showCommentModal: boolean = false;
  userComment = '';
  currentEvent: any = null;
  lastSelectedArea: any = null;
  subAreaLoaded = false;
  alertTypeLoaded = false;
  modalLoading = false;

  /*
    No se llaman todos al mismo tiempo, se van llamando a medida que los necesita el usuario
    y se almacenan. Esto requiere la mejora creando un endpoint que traiga toda la data
    de areas, subAreas y tipos de alertas y que el front las muestre segun lo requerido
    para no hacer consultas recurrentes por cada cambio de elemento seleccionado en el dropdown
  */
  allAreas: OptionCombobox[] = [];
  allSubareas: OptionCombobox[] = [];
  allAlertTypes: OptionCombobox[] = [];
  allRegisterTypes: OptionCombobox[] = [];

  currentSubareas: OptionCombobox[] = [];
  currentAlertTypes: OptionCombobox[] = [];
  currentRegisterType: OptionCombobox[] = [];

  registrationAreaOld: string | null = null;

  public userInfoDto: UserInfoDTO;

  @ViewChild('customMessageTemplate', { static: true })
  customMessageTemplate: TemplateRef<any>;
  constructor(
    injector: Injector,
    protected marklistService: ConsultaMarkListService,
    protected i18n: I18nService,
    protected infoClientSubjectService: InfoClienteService,
    protected formBuilder: FormBuilder,
    protected sinisterService: SinisterService,
    protected formatToService: FormatToService,
    protected messageService: MessageService,
    public notificationRequestService: NotificationRequestService,
    protected authService: AuthService,
    public router: Router
  ) {
    super(injector, {});
  }

  ngOnInit(): void {
    this.loader.view = false;
    this.mostrarBtnAgregarRegistro = true;
    this.userInfoDto = this.authService.userInfoDto;
    this.createForm();
    this.obteinCurrentInfo();
    this.getDynamicFormInputs();
    this.reactiveForm.get('registrationArea').valueChanges.subscribe(value => {
      this.subAreaLoaded = false;
      this.alertTypeLoaded = false;
      this.getOptionSubArea();
    });

    this.reactiveForm.get('subArea').valueChanges.subscribe(value => {
      this.alertTypeLoaded = false;
      this.getOptionAlertType();
    });

    this.reactiveForm.get('alertType').valueChanges.subscribe(value => {
      if (value) {
        this.getOptionRegisterType();
      }
    });
  }

  obteinCurrentInfo() {
    this.infoClient = this.infoClientSubjectService
      .getInfoClienteBehaviorSubject()
      .subscribe({ next: data => {} });
  }

  toggleNewRegister() {
    this.mostrarAgregarRegistro = !this.mostrarAgregarRegistro;
  }

  createForm() {
    this.reactiveForm = this.formBuilder.group({
      registrationArea: ['', Validators.required],
      subArea: ['', Validators.required],
      alertType: ['', Validators.required],
      registerType: ['', Validators.required],
      motivo: ['', [Validators.maxLength(300)]],
      idStatus: ['', Validators.required],
      sistemaBloquear: ['', Validators.required],
      observation: ['', [Validators.maxLength(300)]],
    });
  }

  getDynamicFormInputs() {
    const date = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
    this.sinisterService
      .getDynamicFormInputsAtDate('ML_REGISTRO_ESTADO', date)
      .subscribe({
        next: res => {
          this.dinamicFormInputsData = res;
          const areaField = this.dinamicFormInputsData.find(
            field => field.inputName === 'registrationArea'
          );
          const sistemaBloquearField = this.dinamicFormInputsData.find(
            field => field.inputName === 'sistemaBloquear'
          );

          const allowedAreas = this.getAllowedAreas(
            areaField?.possibleValues || []
          );

          this.allAreas = allowedAreas;

          this.sistemasBloquear = sistemaBloquearField
            ? sistemaBloquearField.possibleValues
            : [];
          this.getOptionState();
        },
        error: err => console.log('error', err),
      });
  }

  getOptionState() {
    this.marklistService.getStatusList(true).subscribe(
      data => {
        this.idStatusList = data;
        this.idStatusListCopy = data.filter(
          x => x.nameStatus !== States.DESBLOQUEADO
        );
        this.idStatusListEditMode = data.filter(
          x => x.nameStatus === States.DESBLOQUEADO
        );
      },
      error => console.log('error', error)
    );
  }

  get revisionStatus() {
    return [
      {
        idStatus: 10,
        nameStatus: 'EN REVISION',
        level: 2,
        active: false,
      },
    ];
  }
  clickReload() {
    this.refresh.emit();
  }

  resetForm(): void {
    this.reactiveForm.get('sistemaBloquear').reset();
    this.reactiveForm.get('registrationArea').reset();
    this.reactiveForm.get('idStatus').reset();
    this.reactiveForm.get('observation').reset();
    this.updateAreaDependingFields();
  }

  updateAreaDependingFields() {
    if (this.registrationAreaOld === this.reactiveForm.get('registrationArea').value) return;

    this.registrationAreaOld = this.reactiveForm.get('registrationArea').value;

    this.reactiveForm.get('subArea').reset();
    this.reactiveForm.get('alertType').reset();
    this.reactiveForm.get('motivo').reset();
    this.reactiveForm.get('registerType').reset();
    this.currentSubareas = [];
    this.currentAlertTypes = [];
    this.currentRegisterType = [];
  }

  onPressUpdate($event: any) {
    console.log('onPressUpdate', $event);

    if ($event.nameStatus === States.DESBLOQUEADO) {
      this.noEditItem = true;
      this.messageService.announcedMessage(
        new InfoMessageDTO(
          'warning',
          this.i18n.getTranslation('NO_SE_PUEDE_EDITAR_ESTADOS_DESBLOQUEADOS'),
          AvlaGenericComponent.TIME_NOTIFICATION
        )
      );
      return;
    }
  }

  onPressUpdateRequest($event: any) {
    console.log('solicitudes');
    console.log('onPressUpdateRequest', $event);
    if ($event.nameStatus === States.DESBLOQUEADO) {
      this.noEditItem = true;
      this.messageService.announcedMessage(
        new InfoMessageDTO(
          'warning',
          this.i18n.getTranslation('NO_SE_PUEDE_EDITAR_ESTADOS_DESBLOQUEADOS'),
          AvlaGenericComponent.TIME_NOTIFICATION
        )
      );
      return;
    }
  }

  getOptionSubArea() {
    if (this.subAreaLoaded || !this.reactiveForm.get('registrationArea').value) return;

    this.isLoadingSubarea = true;
    const areaCdOption = this.reactiveForm.get('registrationArea').value!;

    // Si no existen las subareas cargadas para la opcion, se consulta
    this.sinisterService.getOptionsCombobox(areaCdOption).subscribe({
      next: res => {
        const subareas = this.getAllowedAreas(res);
        this.currentSubareas = subareas;
        this.allSubareas.push(...subareas);
      },
      error: err => console.log(err),
      complete: () => {
        this.isLoadingSubarea = false;
        this.subAreaLoaded = true;
      },
    });
  }

  getOptionAlertType() {
    if (this.alertTypeLoaded || !this.reactiveForm.get('subArea').value) return;

    this.loadingImgAlertType = true;
    const subareaCdOption = this.reactiveForm.get('subArea').value;

    const cdSelect =
      this.formatToService.getCdSelectForAlertTypeFromSubarea(subareaCdOption);

    this.sinisterService.getOptionsCombobox(cdSelect).subscribe({
      next: res => {
        this.allAlertTypes.push(...res);
        this.currentAlertTypes = res;
      },
      error: err => console.log(err),
      complete: () => {
        this.loadingImgAlertType = false;
        this.alertTypeLoaded = true;
      },
    });
  }

  getOptionRegisterType(): void {
    this.loadingImgRegisterType = true;

    const option = this.reactiveForm.get('alertType').value!;
    const registerTypeCdOption =
      this.formatToService.formatToRegisterType(option);

    this.sinisterService.getOptionsCombobox(registerTypeCdOption).subscribe({
      next: res => {
        this.currentRegisterType = res;
        this.allRegisterTypes.push(...res);
        const registerType = res.length > 0 ? res[0].cdOption : null;
        this.reactiveForm.get('registerType')?.setValue(registerType);
      },
      error: err => console.log(err),
      complete: () => (this.loadingImgRegisterType = false),
    });
  }

  clearRegisterType(): void {
    this.reactiveForm.get('registerType').setValue(null);
  }

  // TODO: Verificar en reglas de negocio si es necesaria esta validacion
  getAllowedAreas(res: any[]) {
    return (res || []).filter((area: any) => {
      console.log('area metadata: ', JSON.parse(area.metadata));
      const metadata = JSON.parse(area.metadata);
      return (metadata.auth || []).some((auth: any) => {
        if (AuthService.optionsTree) {
          return this.authService.isAllowedHtmlElement(
            auth?.authElementCode ?? null,
            auth?.authElementName ?? null
          );
        }
        return false;
      });
    });
  }

  onSaveStatus($event): void {
    if (
      !$event.item.update ||
      $event.item.idStatus === $event.item.update.idStatus
    ) {
      this.messageService.announcedMessage(
        new InfoMessageDTO(
          'warning',
          this.i18n.getTranslation('NO_HAY_CAMBIOS_POR_GUARDAR'),
          AvlaGenericComponent.TIME_NOTIFICATION
        )
      );
      return;
    }
    const params = {
      idStatusPerson: $event.item.idStatusPerson,
      idStatus: $event.item.update.idStatus || $event.item.idStatus,
      alertType: $event.item.update.alertType || $event.item.alertType,
    };
    const idStatusPerson = params.idStatusPerson;

    this.marklistService.updateRequest(params, { idStatusPerson });
    this.marklistService.updateState(params, { idStatusPerson });

    this.notificationRequestService.genericNotificacion({
      titleConfirm: this.i18n.getTranslation('GENERAL_GRABAR_ESTADO'),
      msgConfirm: this.i18n.getTranslation(
        'GENERAL_CONFIRMACION_GRABAR_ESTADO'
      ),
      // este es el clicl del modal de confirmacion al momento de aceptar el cambio
      onConfirm: () => {
        this.loader.view = true;
      },
      titleSuccess: this.i18n.getTranslation('GENERAL_OPERACION_EXITOSA'),
      msgSuccess: data => {
        return this.i18n.getTranslation('GENERAL_MESSAGE_SUCCESS_SAVE_ESTADO');
      },

      observer: this.marklistService.updateRequest(params, {
        idStatusPerson,
      }),
      onSuccess: data => {
        this.subscriber.onSaveStatus.next($event);
        this.loader.view = false;
        this.clickReload();
      },
      onError: error => {
        this.loader.view = false;
        let errorData = error?.error?.errorData || 'Error inesperado';

        if (typeof errorData === 'string') {
          errorData = errorData.replace(/[\[\]"]+/g, '');
        }

        this.messageService.announcedMessage(
          new InfoMessageDTO(
            'danger',
            errorData,
            AvlaGenericComponent.TIME_NOTIFICATION
          )
        );
      },
    });
  }

  onSaveRequest($event): void {
    console.log('onSaveRequest', $event);

    this.showCommentModal = true; // Mostrar el modal en lugar del prompt
    this.currentEvent = $event; // Guardar el evento actual
  }

  closeModal(): void {
    this.showCommentModal = false; // Cierra el modal sin hacer nada
  }

  submitComment(): void {
    if (!this.userComment) {
      this.messageService.announcedMessage(
        new InfoMessageDTO(
          'warning',
          'Indícanos la razón de tu solicitud',
          AvlaGenericComponent.TIME_NOTIFICATION
        )
      );
      return;
    }

    const $event = this.currentEvent;

    if ( !$event.item.update || $event.item.idStatus === $event.item.update.idStatus ) {
      
      this.messageService.announcedMessage(
        new InfoMessageDTO(
          'warning',
          this.i18n.getTranslation('NO_HAY_CAMBIOS_POR_SOLICITAR'),
          AvlaGenericComponent.TIME_NOTIFICATION
        )
      );
      this.closeModal();
      this.clickReload();
      return;
    }

    this.sinisterService.getOptionsCombobox("CB_AREA").subscribe({
      next: res => {
        let isAllowed = false;

        const subAreaCombobox = res.find(field => field.label == $event.item.registrationArea);

        const subArea = subAreaCombobox?.metadata
          ? JSON.parse(subAreaCombobox.metadata)
          : null;

        let authElement = null;
        if (Array.isArray(subArea?.auth)) {
          authElement = subArea.auth[0];
        } else if (subArea?.auth) {
          authElement = subArea.auth;
        }

        if (AuthService.optionsTree) {
          isAllowed = this.authService.isAllowedHtmlElement(
            authElement?.authElementCode ?? null,
            authElement?.authElementName ?? null
          );
        }        

        if (!isAllowed && this.validateAdminProfile() &&
          States.DESBLOQUEADO === ($event.item.update.nameStatus)) {
            isAllowed = true;
        }


        if (!isAllowed) {
          this.noEditItem = true;

          this.messageService.announcedMessage(
            new InfoMessageDTO(
              'warning',
              this.i18n.getTranslation('NO_PERMISO_EDITAR_BLOQUEO_ADMIN'),
              AvlaGenericComponent.TIME_NOTIFICATION
            )
          );
          this.closeModal();
          this.clickReload();
          return;

        }
          
      },
      error: err => console.log(err),
    });

    const params = {
      idStatusPerson: $event.item.idStatusPerson,
      idStatus: $event.item.update.idStatus || $event.item.idStatus,
      alertType: $event.item.update.alertType || $event.item.alertType,
      comments: this.userComment,
    };

    const idStatusPerson = params.idStatusPerson;
    this.modalLoading = true;
    iif(
      () => this.isAllowedToBlockDirectly(),
      this.marklistService.updateState(params, { idStatusPerson }),
      this.marklistService.updateRequest(params, { idStatusPerson })
    ).subscribe(
      result => {
        console.log('response:', result);
        this.clickReload();
        this.closeModal();
        this.modalLoading = false;
      },
      error => {
        console.error('error:', error);
        let errorCode = error?.error?.errorCode;
        const errorMessage =
          errorCode && errorCode.includes('ALREADY_REQUESTED')
            ? this.i18n.getTranslation('ALREADY_REQUESTED_EXCEPTION')
            : 'Error inesperado';
        this.messageService.announcedMessage(
          new InfoMessageDTO(
            'warning',
            errorMessage,
            AvlaGenericComponent.TIME_NOTIFICATION
          )
        );
        this.modalLoading = false;
        this.closeModal();
      }
    );
  }

  onDeleteStatus(item: any): void {
    console.log('verifyDelete', item);
  }

  onDeleteRequest(item: any): void {
    console.log('verifyDelete on Requests', item);
  }

  onStatusChange($event: any, item: any): void {
    if (!$event) return;
    if (!item.isEdit) return;
    console.log('onStatusChange', $event, item);
    item.update = {
      ...item.update,
      idStatus: $event.idStatus,
      nameStatus: $event.nameStatus,
    };
  }

  onAlertTypeChange($event: any, item: any): void {
    if ($event) {
      console.log('onAlertTypeChange', $event, item);
      item.update = {
        ...item.update,
        alertType: $event.cdOption,
      };
    }
  }

  validateAdminProfile(): boolean {
    return this.userInfoDto.groups.some(
      group =>
        group.name === 'MARK-LIST - Administrador' || group.name === 'SYS_ADMIN'
    );
  }

  submitForm() {
    this.loadingImg = true;
    if (!this.reactiveForm.valid) return;

    const statusRegisterDTO: StatusRegisterDTO = this.buildDataToSave();

    this.marklistService
      .newStatusRegister(statusRegisterDTO, this.isAllowedToBlockDirectly())
      .subscribe({
        next: () => {
          this.messageService.announcedMessage(
            new InfoMessageDTO(
              'success',
              'Se ha ingresado registro',
              AvlaGenericComponent.TIME_NOTIFICATION
            )
          );
          this.loadingImg = false;
          this.clickReload();
          this.mostrarAgregarRegistro = false;
          this.resetForm();
        },
        error: err => {
          console.log(err);

          this.messageService.announcedMessage(
            new InfoMessageDTO(
              'danger',
              'No se a podido ingresar el registro. Vuelva a intentarlo',
              AvlaGenericComponent.TIME_NOTIFICATION
            )
          );
          this.loadingImg = false;
          return;
        },
      });
  }

  buildDataToSave(): StatusRegisterDTO {
    const statusRegisterDTO: StatusRegisterDTO = {
      idPerson: this.personData?.idPerson,
      dniPerson: this.personData?.dniPerson,
      namePerson: this.personData?.namePerson,
      personType: this.personData?.personType,
      identificationType: this.personData?.identificationType,
      registrationArea: this.reactiveForm.get('registrationArea').value,
      subArea: this.reactiveForm.get('subArea').value,
      alertType: this.reactiveForm.get('alertType').value,
      registerType: this.reactiveForm.get('registerType').value,
      idStatus: parseInt(this.reactiveForm.get('idStatus').value),
      systemsBlocked: this.reactiveForm.get('sistemaBloquear').value,
      observation: this.reactiveForm.get('observation').value,
      countSinister: 0,
      registerDate:
        moment(new Date()).add(1, 'days').format('YYYY-MM-DD') + 'T00:00:00',
    };

    // Area
    statusRegisterDTO.registrationArea = this.allAreas.find(
      area => area.cdOption === statusRegisterDTO.registrationArea
    ).label;

    // Subrea
    statusRegisterDTO.subArea = this.allSubareas.find(
      subarea => subarea.cdOption === statusRegisterDTO.subArea
    ).label;

    // Tipo de alerta - motivo
    const motive = this.reactiveForm.get('motivo').value;

    statusRegisterDTO.alertType = motive
      ? `Otro: ${motive}`
      : this.allAlertTypes.find(
          alertType => alertType.cdOption === statusRegisterDTO.alertType
        ).label;

    // Tipo de registro
    statusRegisterDTO.registerType = this.allRegisterTypes.find(
      registerType => registerType.cdOption === statusRegisterDTO.registerType
    ).label;

    return statusRegisterDTO;
  }

  navigateToSolicitudes() {
    this.router.navigate(['/pending-requests']);
  }

  isAllowedToBlockDirectly(): boolean {
    return this.authService.isAllowedHtmlElement(19506, 'BTN_DIRECT_BLOCK');
  }

  onCheckboxChange(event: Event, value: string): void {
    const checkbox = event.target as HTMLInputElement;
    const currentValues = this.reactiveForm.get('sistemaBloquear').value || [];
  
    if (checkbox.checked) {
      this.reactiveForm.get('sistemaBloquear').setValue([...currentValues, value]);
    } else {
      this.reactiveForm
        .get('sistemaBloquear')
        .setValue(currentValues.filter((v: string) => v !== value));
    }
  }
}
